/**
 * Client mirror of the server's Reviewed rule (functions/src/issueTriage/
 * services/issueWorkflow.ts), used ONLY for optimistic cache updates. The
 * server decides; the refetch after every mutation replaces these guesses.
 *
 * Reviewed = the developers' pickup queue: owned + a non-blank direction.
 */
import type { IssueReport, IssueStatus } from "../../types/issue-triage";

type Readiness = Pick<IssueReport, "owner" | "developerNotes">;

export function isReadyForPickup(issue: Readiness): boolean {
  return !!issue.owner?.uid && (issue.developerNotes ?? "").trim().length > 0;
}

export function reviewQueueStatus(issue: Readiness): IssueStatus {
  return isReadyForPickup(issue) ? "reviewed" : "needs_review";
}

/** After an owner/direction edit: only needs_review <-> reviewed moves. */
export function statusAfterEdit(issue: Readiness & Pick<IssueReport, "status">): IssueStatus {
  return issue.status === "needs_review" || issue.status === "reviewed"
    ? reviewQueueStatus(issue)
    : issue.status;
}

/** Statuses an Approve may move (later ones are never pulled back). */
export const APPROVABLE_STATUSES: readonly string[] = [
  "new",
  "analyzing",
  "pending_analysis",
  "needs_review",
  "reviewed",
];
